import { render, staticRenderFns } from "./remCom.vue?vue&type=template&id=5d6f0824&scoped=true"
import script from "./remCom.vue?vue&type=script&lang=js"
export * from "./remCom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/rem.css?vue&type=style&index=0&id=5d6f0824&prod&scoped=true&lang=css&external"
import style1 from "./remCom.vue?vue&type=style&index=1&id=5d6f0824&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f0824",
  null
  
)

export default component.exports